import { useMemo } from 'react';
import routes_api from '../../connections/routes_api';
import { useModuleAccess } from '../../connections/useModuleAccess';
import useOfflineFirstData from 'services/useOfflineFirstData';

export function useEmbeddedNotepadData() {
  const { hasAccess } = useModuleAccess();
  const hasNotepadAccess = hasAccess('notepad');

  const {
    data: notesData,
    isLoading: isNotesLoading,
    isLoadingNetwork: isNotesLoadingNetwork,
    refresh: refreshNotes,
    updateOptimistically: updateNotesOptimistically,
  } = useOfflineFirstData(routes_api.notepad_notes, { enabled: hasNotepadAccess });

  const {
    data: clustersData,
    isLoading: isClustersLoading,
    refresh: refreshClusters,
  } = useOfflineFirstData(routes_api.notepad_clusters, { enabled: hasNotepadAccess });

  const notes = useMemo(() => {
    if (!notesData || !Array.isArray(notesData)) return [];
    return [...notesData].sort((a, b) => {
      const dateA = new Date(a.updated_at || a.created_at || 0).getTime();
      const dateB = new Date(b.updated_at || b.created_at || 0).getTime();
      return dateB - dateA;
    });
  }, [notesData]);

  const clusters = useMemo(() => {
    if (!clustersData || !Array.isArray(clustersData)) return [];
    return clustersData;
  }, [clustersData]);

  return {
    hasNotepadAccess,
    notes,
    clusters,
    isNotesLoading,
    isNotesLoadingNetwork,
    isClustersLoading,
    refreshNotes,
    updateNotesOptimistically,
    refreshClusters,
  };
}
